const contractHTML = () => {
  let dummyContractHTML = '<div>';
  for (let i = 0; i < 100; i += 1) {
    dummyContractHTML += '<p>Lorem ipsum dolor sit amet</p>';
  }
  dummyContractHTML += '<p>Fin</p></div>';
  return dummyContractHTML;
};

const mocks = {
  Int: (): number => 123456789,
  String: (): string => 'String',
  Float: (): number => 0.123,
  Customer: () => ({
    customerId: '1',
    name: 'Nombre',
    firstSurname: 'Apellido',
    rut: '11.111.111-1',
    phone: '912345678',
    email: 'email@example.com',
    commune: 'Vitacura',
  }),
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  Query: () => ({
    termsAndConditionsTemplateHTML: () => contractHTML(),
  }),
};

export default mocks;
